import { render, staticRenderFns } from "./ExhibitInputs.vue?vue&type=template&id=59fc2b7b&scoped=true&"
import script from "./ExhibitInputs.vue?vue&type=script&lang=js&"
export * from "./ExhibitInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fc2b7b",
  null
  
)

export default component.exports